// extracted by mini-css-extract-plugin
module.exports = {"preview-loader":"S_c0","previewLoader":"S_c0"};